<template>
  <svg
    class="stroke-lush-green duration-300"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 5.335H6.667V24.663C6.667 25.7676 7.56243 26.663 8.667 26.663H20"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.3333 20L25.3333 16M25.3333 16L21.3333 12M25.3333 16H12"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup></script>

<style scoped></style>
